import * as yup from 'yup';
import { requiredField } from '../../../utils/forms';

const contactSchema = yup.object({
  fullName: yup.string().required(requiredField('Nome Completo')),
  email: yup
    .string()
    .email('Email inválido')
    .required(requiredField('E-mail'))
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Email inválido'),
  phone: yup
    .string()
    .required(requiredField('Telefone'))
    .test('phone-length', 'Telefone deve estar completo', (value) => {
      if (!value) return false;
      const cleanPhone = value.replace(/[^\d]/g, '');
      return cleanPhone.length >= 11;
    }),
  cpf: yup
    .string()
    .required(requiredField('CPF'))
    .test('cpf-length', 'CPF deve conter 11 dígitos', (value) => {
      if (!value) return false;
      const cleanCpf = value.replace(/[^\d]/g, '');
      return cleanCpf.length === 11;
    }),
  jobTitle: yup.string(),
  profiles: yup.array().of(yup.string()).min(1, 'É necessário selecionar pelo menos um perfil'),
});

const addressSchema = yup.object({
  street: yup.string().required(requiredField('Rua')),
  number: yup.number().required(requiredField('Numero')),
  complement: yup.string().optional().nullable(),
  city: yup.string().required(requiredField('Cidade')),
  district: yup.string().required(requiredField('Bairro')),
  state: yup.string().required(requiredField('Estado')),
  zipcode: yup.string().required(requiredField('CEP')),
});

const companySchema = yup.object({
  companyName: yup.string().required(requiredField('Razão Social')),
  tradingName: yup.string().required(requiredField('Nome Fantasia')),
  cnpj: yup.string().required(requiredField('CNPJ')),
  telephone: yup.string().required(requiredField('Telephone')),
  email: yup.string().email().required(requiredField('Email')),
  website: yup.string().optional().nullable(),
});

const partnerSchema = yup.object({
  id: yup.string(),
  ...addressSchema.fields,
  ...companySchema.fields,
  contactName: yup.string().required(requiredField('Nome de contato')),
  contactNumber: yup.string().required(requiredField('Numero de Contato')),
  contactEmail: yup.string().email().required(requiredField('Email de contato')),
  contacts: yup.array().of(contactSchema).min(1, 'É necessário adicionar pelo menos um contato'),
});

export default partnerSchema;
